import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=2c8bc130"
import script from "./SignDocument.vue?vue&type=script&lang=js"
export * from "./SignDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports